import ChristmasGreeting from '@/components/ChristmasGreeting'
import Headers from '@/components/Headers'
import HelpPanel from '@/components/HelpPanel'
import Sidebar from '@/components/Sidebar'
import TetGreeting from '@/components/TetGreeting'
import TourHint from '@/components/TourHint'

import useInnerWidth from '@/hooks/useInnerWidth'
import { useAppStore } from '@/stores/useAppStore'

const SIDEBAR_WIDTH_EXPANDED = 241
const SIDEBAR_WIDTH_COLLAPSED = 58

const MainLayout = ({ children }: { children: React.ReactNode }) => {
    const { sideBarFull, isShowHelp, helpContent, helpTitle, hideHelp } =
        useAppStore((state) => state)

    const { isMobile } = useInnerWidth()

    return (
        <main className="flex">
            <div className="md:fixed static top-0 bg-white z-[9999]">
                <Sidebar />
            </div>

            <section
                className="flex-1 flex flex-col min-h-svh transition-all duration-300"
                style={{
                    marginLeft: isMobile
                        ? '0px'
                        : sideBarFull
                          ? `${SIDEBAR_WIDTH_EXPANDED}px`
                          : `${SIDEBAR_WIDTH_COLLAPSED}px`,
                    width: isMobile
                        ? '100%'
                        : `calc(100% - ${sideBarFull ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_COLLAPSED}px)`,
                }}
            >
                <div className="sticky top-0 z-50 bg-white">
                    <Headers />
                </div>
                <div className="md:mb-0 mb-[60px] p-4 flex-1 w-full">
                    {children}
                </div>
            </section>

            <HelpPanel
                isOpen={isShowHelp}
                content={helpContent}
                title={helpTitle}
                onClose={hideHelp}
            />

            {/* Event greetings - each shows once per event period */}
            <ChristmasGreeting />
            <TetGreeting />
            {/* Tour hint - shows when there's a pending tour for current route */}
            <TourHint />
        </main>
    )
}

export default MainLayout
